import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    IconButton,
    Collapse,
    Box
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';

const ErrorAlert = ({ error, onClose }) => {

    const location = useLocation();
    const [expanded, setExpanded] = useState(false);

    const lines = error?.message?.split('\n');
    const [width, setWidth] = useState(expanded ? '100%' : '600px');

    useEffect(() => {
        setWidth(expanded ? '100%' : '600px'); // 600px corresponds to 'sm'
    }, [expanded]);

    useEffect(() => {
        onClose();
    }, [location.pathname]);

    useEffect(() => {
        setExpanded(false);
    }, [error]);

    return (
        <Dialog open={!!error} onClose={onClose} maxWidth={expanded ? '100%' : 'sm'} fullWidth sx={{
            width,
            maxWidth: '100%',
            transition: 'width 0.3s ease',
            mx: 'auto',
        }}>
            <DialogTitle>
                <Box display='flex' alignItems='center' justifyContent='space-between'>
                    <Box display='flex' alignItems='center' gap={1}>
                        <ErrorOutlineIcon color='error' />
                        <Typography variant='h6'>{error?.title || 'Error'}</Typography>
                    </Box>
                    <IconButton onClick={onClose} size='small'>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                {lines?.map((line, index) => (
                    <Typography key={index}>{line}</Typography>
                ))}
                {error?.detail && (
                    <Collapse in={expanded}>
                        <Typography variant='body2' color='error' mt={2}>
                            {error.detail}
                        </Typography>
                    </Collapse>
                )}
            </DialogContent>
            <DialogActions>
                <Box flexGrow={1}>
                    {error?.detail && (
                        <Button onClick={() => setExpanded(!expanded)}>
                            {expanded ? 'Hide Details' : 'Show Details'}
                        </Button>
                    )}
                </Box>
                <Box>
                    <Button onClick={onClose} variant='text'>Close</Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default ErrorAlert;
